import {useTheme} from "@mui/material/styles";
import {
    Box,
    Divider,
    Card,
    CardContent,
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Avatar,
    Typography,
} from "@mui/material";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import {useParams} from "react-router-dom";
import {getI18nContent} from "../../config/i18nConfig";
import {Fragment} from "react";

export const WordPressToolsTrackingLTL = ({trackingData, isLongDistanceMoving = false}) => {

    const theme = useTheme();
    const {lng} = useParams();
    const uiText = getI18nContent(lng, 'LTLTools');

    return (
        <Card sx={{mt: 3, borderRadius: theme.shape.lg, boxShadow: theme.shadows[2]}}>
            <CardContent>
                <Box sx={{display: 'flex', alignItems: 'center', gap: 2}}>
                    {trackingData?.iconURI && (
                        <Box
                            component="img"
                            src={isLongDistanceMoving ? 'https://storage.googleapis.com/uucargo-resource/image/icon/UUCargo-icon.png' : `https://storage.googleapis.com/${trackingData.iconURI}`}
                            alt={trackingData.accountBase}
                            sx={{
                                width: 80,
                                height: 'auto',
                                maxHeight: 60,
                                objectFit: 'contain',
                                display: 'block',
                                borderRadius: theme.shape.borderRadius
                            }}
                            onError={(e) => {
                                e.target.style.display = 'none';
                            }}
                        />
                    )}

                    <Box>
                        <Typography
                            variant="h6"
                            fontWeight="800"
                            sx={{textTransform: 'uppercase', lineHeight: 1.1}}
                        >
                            {isLongDistanceMoving ? 'UUCargo' : trackingData?.accountBase}
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2}}>
                    <Typography variant="subtitle1" fontWeight="bold">
                        {uiText.search.results.status}: <Box component="span"
                                                             sx={{color: 'primary.main'}}>{trackingData.trackingResponse?.status}</Box>
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        {uiText.search.results.lastUpdate}: {trackingData.trackingResponse?.deliveryDate || 'N/A'}
                    </Typography>
                </Box>
                <Divider/>
                <List sx={{width: '100%', bgcolor: 'background.paper'}}>
                    {trackingData?.trackingResponse?.activity?.map((item, index) => (
                        <ListItem
                            key={index}
                            alignItems="flex-start"
                            sx={{
                                borderLeft: index === 0 ? `4px solid ${theme.palette.success.main}` : '4px solid #eee',
                                mb: 1,
                                backgroundColor: index === 0 ? 'rgba(76, 175, 80, 0.04)' : 'transparent'
                            }}
                        >
                            <ListItemAvatar>
                                <Avatar sx={{
                                    bgcolor: index === 0 ? 'success.main' : 'grey.400',
                                    width: 32,
                                    height: 32
                                }}>
                                    {index === 0 ? <CheckCircleIcon fontSize="small"/> :
                                        <LocalShippingIcon fontSize="small"/>}
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                                primary={
                                    <Typography variant="subtitle2" fontWeight={index === 0 ? 700 : 500}>
                                        {item.trackingEvent}
                                    </Typography>
                                }
                                secondary={
                                    <Fragment>
                                        <Typography component="span" variant="caption" color="text.primary"
                                                    display="block">
                                            {item.date}
                                        </Typography>
                                        <Typography component="span" variant="body2" color="text.secondary">
                                            {item.description}
                                        </Typography>
                                        {item.address.address && (
                                            <Box sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                mt: 0.5,
                                                color: 'primary.main'
                                            }}>
                                                <LocationOnIcon sx={{fontSize: 14, mr: 0.5}}/>
                                                <Typography
                                                    variant="caption">{item.address.address}</Typography>
                                            </Box>
                                        )}
                                    </Fragment>
                                }
                            />
                        </ListItem>
                    ))}
                </List>
            </CardContent>
        </Card>
    )
}